import * as React from 'react';
import { ITabActivityContext } from './types';

export const TabActivityContext = React.createContext<ITabActivityContext>(null);

export const CLASS_BOARD_ACTIVITY = 'board-activity';
export const SCROLL_OFFSET = 200; // px снизу
